import React from "react";
import "./NewsMenu.css";
import { NewsMenuType } from "../Types/Configuration";
import { toLocaleDateString } from "../Utilities/StringUtils";

interface NewsMenuProps {
  newsMenu: NewsMenuType[];
  isLoading: boolean;
}
const NewsMenu: React.FC<NewsMenuProps> = ({ newsMenu, isLoading }) => {
  if (isLoading) {
    return <div className="news-container loading-container">
    <div className="loading"></div>;
    </div>
  }
  return (
    <div className="news-container">
      <div className="news-menu-title">Ajankohtaista</div>
      {newsMenu.map((item, index) => (
        <div key={index} className="news-item">
          <div className="news-date">{toLocaleDateString(item.date)}</div>
          <div className="news-title">{item.title}</div>
          <div className="news-description">{item.description}</div>
        </div>
      ))}
    </div>
  );
};
export default NewsMenu;
